import React from 'react';

import MultiAdditional from './components/multi-additional';
import SingleAdditional from './components/single-additional';

import useAdditionalGroupsCart from 'modules/cart/util/use-additional-groups-cart';
import {
  AdditionalGroupConfigProps,
  AdditionalGroupConfigTypeEnum,
} from 'modules/products/types';
import Column from 'shared/components/column';
import Row from 'shared/components/row';
import {LightText, RegularText, SemiBoldText} from 'shared/components/text';

const AdditionalGroupConfig: React.FC<AdditionalGroupConfigProps> = ({
  id,
  min,
  max,
  isFree,
  additionalGroup,
  productId,
  type,
  additionalPricesWhenFree,
}) => {
  const {name, additionals} = additionalGroup;
  const {getAdditionalGroupCart} = useAdditionalGroupsCart(productId);
  const additionalDraft = getAdditionalGroupCart(id);

  const quantity =
    additionalDraft?.reduce(
      (sum, additional) => sum + additional.quantity,
      0,
    ) ?? 0;

  const getTranslatedType = () => {
    if (type === AdditionalGroupConfigTypeEnum.average)
      return 'Média dos preços';
    if (type === AdditionalGroupConfigTypeEnum.highest_value)
      return 'Maior valor';

    return 'Soma';
  };

  return (
    <Container>
      <Section style={{gap: 5}}>
        <Column>
          <SemiBoldText size="small">{name}</SemiBoldText>
          <LightText size="small">{getTranslatedType()}</LightText>
        </Column>
        <Row justifyContent="space-between">
          <RegularText size="small">
            {quantity} de {max}
          </RegularText>
          {min >= 1 && (
            <Mandatory>
              <SemiBoldText size="extra-small" color="white">
                OBRIGATÓRIO
              </SemiBoldText>
            </Mandatory>
          )}
          {min === 0 && (
            <Optional>
              <SemiBoldText size="small" color="white">
                OPCIONAL
              </SemiBoldText>
            </Optional>
          )}
        </Row>
      </Section>
      {additionals.map((additional) =>
        max === 1 ? (
          <SingleAdditional
            key={additional.id}
            {...{
              ...additional,
              additionalGroupConfigId: id,
              productId,
              isFree,
              additionalPricesWhenFree,
            }}
          />
        ) : (
          <MultiAdditional
            key={additional.id}
            {...{
              ...additional,
              isFree,
              additionalGroupConfigId: id,
              disabled: max === quantity,
              productId,
              additionalPricesWhenFree,
            }}
          />
        ),
      )}
    </Container>
  );
};

export default AdditionalGroupConfig;

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  padding: 15px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
`;

const Mandatory = styled.div`
  border-radius: 3px;
  padding: 5px;
  background-color: black;
`;

const Optional = styled.div`
  border-radius: 3px;
  padding: 5px;
  background-color: #1ec25c;
`;
